import { clampFontSize, styled } from "utils";

const Text = styled("span", {
  variants: {
    variant: {
      span: {},
      h1: { fontSize: clampFontSize("$7", "$8", 2.5), marginBottom: "$5" },
      h2: {
        fontSize: clampFontSize("$6", "$7", 1.5),
        marginBottom: "$3",
        fontWeight: "$bold",
        "@bp3": { marginBottom: "$4" },
      },
      h3: {
        fontSize: "$6",
        marginBottom: "$2",
        fontWeight: "$bold",
        lineHeight: 1.2,
      },
    },
  },
});

export type TextProps = React.ComponentProps<typeof Text>;

export { Text };
